import ButtonComponent from '../Generics/Buttons/button-component'
import { useSociogramActions } from '@BUP/hooks/Sociogram/useSociogramContext'
import styles from './sociogram-switcher.module.scss'
import { useTranslation } from 'react-i18next'

const SociogramSwitcher = ({ sociogramState, events, disabled }) => {
  const i18n = useTranslation()

  const { setSociogramId, setSociogramState } = useSociogramActions()

  const handleSociogram = index => {
    const selectedEvent = events[index]
    setSociogramState(index)
    setSociogramId(selectedEvent?.activityId ?? null)
  }

  return (
    <div
      className={styles.buttons_wrapper}
      data-test='sociogram-switcher-wrapper'
    >
      <ButtonComponent
        buttonText={i18n.t('pages.data.sociogram.activeSociogramEce.firstSociogramButton')}
        shape='rectangle'
        size='medium'
        colorType='tertiary'
        onClick={() => {
          handleSociogram(0)
        }}
        activeTertiary={sociogramState === 0}
      />
      <ButtonComponent
        buttonText={i18n.t('pages.data.sociogram.activeSociogramEce.secondSociogramButton')}
        shape='rectangle'
        size='medium'
        colorType='tertiary'
        disabled={disabled}
        onClick={() => {
          handleSociogram(1)
        }}
        activeTertiary={sociogramState === 1}
      />
    </div>
  )
}

export default SociogramSwitcher
